import { render, staticRenderFns } from "./OrdersWeightButton.vue?vue&type=template&id=7fb73f32&"
import script from "./OrdersWeightButton.vue?vue&type=script&lang=js&"
export * from "./OrdersWeightButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports